import React, { useState, useEffect } from "react";
import { Spinner } from "../../StyledComponent";
import AcordeonFAQ from "../AcordeonFaq";

import { getPerguntasFrequentes } from "../../../services/meAjuda";

import "./styles.scss";

const PerguntasFrequentes = ({ tema }) => {
  const [loading, setLoading] = useState(true);
  const [perguntasFrequentes, setPerguntasFrequentes] = useState([]);

  useEffect(() => {
    get();
  }, []);

  async function get() {
    let resultGetPerguntasFrequentes = await getPerguntasFrequentes();
    mapSubjects(resultGetPerguntasFrequentes);
    setLoading(false);
  }

  const mapSubjects = (faq) => {
    const groupedFaq = [];
    for (let question of faq) {
      const group = groupedFaq.find((g) => g.subject == question.Assunto);
      if (group == undefined) {
        groupedFaq.push({
          subject: question.Assunto,
          questions: [question],
        });
      } else {
        group.questions.push(question);
      }
    }
    setPerguntasFrequentes(groupedFaq);
  };

  if (loading) return <Spinner />;

  return (
    <>
      <AcordeonFAQ tema={tema} arrayFAQ={perguntasFrequentes} />
    </>
  );
};

export default PerguntasFrequentes;
